import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/assets/scss/_reset.scss'
import '@/assets/scss/_fonts.scss'
import '@/assets/scss/_vars.scss'
import '@/assets/scss/_common.scss'

import '@/assets/js/scripts.js'

const app = createApp(App)
const head = createHead()

app.use(store).use(router).use(head).mount('#app')
